'use client';

import React from 'react';
import { useNotificationStore } from '@/store/notification-store';
import { Toast } from '@/components/ui/toast';
import { isExternalUrl } from '@/lib/utils/url';

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const { notifications, markAsRead, removeNotification } = useNotificationStore();

  const handleAction = (notification: { id: string; actionUrl?: string }) => {
    markAsRead(notification.id);
    if (notification.actionUrl && !isExternalUrl(notification.actionUrl)) {
      window.location.href = notification.actionUrl;
    }
  };

  return (
    <>
      {children}
      <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
        {notifications
          .filter((n) => !n.read)
          .slice(0, 5)
          .map((notification) => (
            <Toast
              key={notification.id} id={notification.id}
              type={notification.type}
              title={notification.title}
              message={notification.message}
              onClose={() => removeNotification(notification.id)}
              onClick={() => handleAction(notification)}
            />
          ))}
      </div>
    </>
  );
}
